// @ts-strict-ignore
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Arrange, Button } from "@aviary";
import { l } from "@clinic/emerson/locales";
import FsIcon from "@emerson/assets/svg/FsIcon";
import { RsoModal } from "@emerson/components/RsoModal/RsoModal";
import { useHasMultipleStorePlatformsQuery } from "@shared/data/queries/HasMultipleStorePlatformsQuery/HasMultipleStorePlatforms.query";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";

import * as styles from "./BridgeBanner.styles";

const BridgeBanner = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const { isUnauthenticated } = useSharedGlobalConfig();
  const { data: practitioner } = useHasMultipleStorePlatformsQuery({
    skip: isUnauthenticated,
  });

  const hasMultipleStorePlatforms = practitioner?.currentOffice?.user?.hasMultipleStorePlatforms;

  const [isOpen, setIsOpen] = useState(false);

  if (isUnauthenticated || hasMultipleStorePlatforms) {
    return null;
  }

  return (
    <div
      data-testid="rso-bridge-banner"
      css={[styles.BannerContainer, !tablet.greaterThan && styles.MobileBanner]}
    >
      <RsoModal
        hasMultipleStorePlatforms={hasMultipleStorePlatforms}
        isOpen={isOpen}
        onClose={() => setIsOpen(!isOpen)}
      />
      <FsIcon />
      <Arrange
        isVertical={!tablet.greaterThan}
        alignment="center"
        justify={tablet.greaterThan ? "start" : "center"}
        spacing="large"
      >
        <div css={styles.BannerContent}>{t(l.homepage.rso.TryFullscript)}</div>
        <Button onClick={() => setIsOpen(!isOpen)} size="small" intention="lightFilled">
          {t(l.homepage.rso.AccessFs)}
        </Button>
      </Arrange>
      <div></div>
    </div>
  );
};

export { BridgeBanner };
